import React, {  createContext, useContext } from 'react';

const ListRefContext = createContext();

export const ListRefProvider = ({ children }) => {
  let listRefs = [];
  return (
    <ListRefContext.Provider value={{ listRefs }}>
      {children}
    </ListRefContext.Provider>
  );
};

export const useListRefContext = () => useContext(ListRefContext);
